import React from 'react'

const RotatingBanner = () => {
  return (
    <div className="rotating-banner fixed bottom-0 z-40 h-[70px] bg-gradient1">
      <div className="rotating-banner-content flex h-[70px] items-center">
        <p className="banner-text rotating-first">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
        <p className="banner-text">Relentless</p>
        <p className="banner-text">DROP LIVE</p>
      </div>
    </div>
  )
}

export default RotatingBanner
